import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const supportedLanguages = ["en", "de"] as const;

export type SupportedLanguage = (typeof supportedLanguages)[number];

interface LanguageState {
  current: SupportedLanguage;
  supported: SupportedLanguage[];
}

const initialState: LanguageState = {
  current: "en",
  supported: [...supportedLanguages],
};

const languageSlice = createSlice({
  name: "language",
  initialState,
  reducers: {
    setLanguage: (state, action: PayloadAction<SupportedLanguage>) => {
      const lang = action.payload;

      if (state.supported.includes(lang)) {
        state.current = lang;
      } else {
        console.warn(`⚠️ Unsupported language: ${lang}`);
      }
    },
  },
});

export const { setLanguage } = languageSlice.actions;
export default languageSlice.reducer;
